// @flow
import * as React from 'react';
import { Text } from '@locus-taxy/neo-ui';

import useAccessDeniedMessage from './useAccessDeniedMessage';

type TextProps = $Diff<React.ElementConfig<typeof Text>, { children: any }>;

type Props = {
    ...TextProps,
    action: string
};

const AccessDeniedMessage: React.AbstractComponent<
    Props,
    HTMLElement
> = React.forwardRef(({ action, ...textProps }, ref): React.Node => {
    const msg = useAccessDeniedMessage({ action });
    return (
        <Text {...textProps} ref={ref}>
            {msg}
        </Text>
    );
});

export default AccessDeniedMessage;
